import React from "react";
import { Toolbar, Divider, Box } from "@mui/material";
import EstateSelect from "../components/EstateSelect";

import RefreshButton from "./RefreshButton";

function LocationFilterToolbar({ classes, noTicketFilter = true }) {
  return (
    <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
      <Box sx={{ flexGrow: 1 }}>
        <EstateSelect />
      </Box>

      {noTicketFilter && (
        <React.Fragment>
          <Divider orientation="vertical" flexItem />
          <RefreshButton />
        </React.Fragment>
      )}
    </Toolbar>
  );
}

export default LocationFilterToolbar;
